import { bootstrapApplication, provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { MessageService } from "primeng/api";

bootstrapApplication(AppComponent, {
    ...appConfig, // spread your existing config
    providers: [
        MessageService,
        ...(appConfig.providers || []),
        provideAnimations(),
        provideClientHydration()
    ]
}).catch(err => console.error(err));
